// src/composables/useAuth.js
import { useAuthStore } from '@/stores/authStore'
import { api } from '@/plugins/axios'
import moment from 'moment'

export function useAuth() {
  const authStore = useAuthStore()

  // ✅ Validate access token and set it if valid
  function validateToken(token, expireAt) {
    if (!token || !expireAt) {
      api.defaults.headers.common.Authorization = ''
      return false
    }

    const now = new Date().getTime()
    const expiry = moment(expireAt, 'YYYY-MM-DD HH:mm:ss').valueOf() // milliseconds

    if (now < expiry) {
      api.defaults.headers.common.Authorization = `Bearer ${token}`
      return true
    } else {
      api.defaults.headers.common.Authorization = ''
      return false
    }
  }

  // ✅ Check if the user is authenticated (wrapper)
  function isAuthenticated() {
    const token = authStore?.bearer?.access_token || localStorage.getItem('access_token')
    const expireAt = authStore?.bearer?.expires_at
    return validateToken(token, expireAt)
  }

  // ✅ Logout helper
  async function logout() {
    try {
      console.log('Logging out...')
      await api.get('logout')
    } catch (e) {
      console.error('Logout API failed', e)
    } finally {
      // Clear auth state
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      localStorage.removeItem('bearer')
      authStore.$reset()
      delete api.defaults.headers.common.Authorization
    }
  }

  return {
    validateToken,
    isAuthenticated,
    logout,
  }
}
